var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5817 11.5817 8 16 8H32C36.4183 8 40 11.5817 40 16V32C40 36.4183 36.4183 40 32 40H16C11.5817 40 8 36.4183 8 32V16Z",
    fill: "#5062F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6346 16.6346C17.0409 16.2283 17.592 16 18.1667 16H29.8333C30.408 16 30.9591 16.2283 31.3654 16.6346C31.7717 17.0409 32 17.592 32 18.1667V29.8333C32 30.408 31.7717 30.9591 31.3654 31.3654C30.9591 31.7717 30.408 32 29.8333 32H18.1667C17.592 32 17.0409 31.7717 16.6346 31.3654C16.2283 30.9591 16 30.408 16 29.8333V18.1667C16 17.592 16.2283 17.0409 16.6346 16.6346ZM18.1667 17C17.8572 17 17.5605 17.1229 17.3417 17.3417C17.1229 17.5605 17 17.8572 17 18.1667V29.8333C17 30.1428 17.1229 30.4395 17.3417 30.6583C17.5605 30.8771 17.8572 31 18.1667 31H23.5V17H18.1667ZM24.5 17V31H29.8333C30.1428 31 30.4395 30.8771 30.6583 30.6583C30.8771 30.4395 31 30.1428 31 29.8333V18.1667C31 17.8572 30.8771 17.5605 30.6583 17.3417C30.4395 17.1229 30.1428 17 29.8333 17H24.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.0235294 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.0132ac80e5c3bea6ac835ebefdb64f8b.svg";
export { ForwardRef as ReactComponent };